export const calculatePlannedWeight = (
  size,
  bulk,
  reelOd,
  coreOd,
  plannedReels
) => {
  if (bulk === 0 || plannedReels === 0) {
    return 0;
  } else {
    const value =
      (3.14 *
        parseFloat(size) *
        (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4);
    return value;
  }
};

export const calculatePlannedReels = (
  size,
  weight,
  bulk,
  reelOd,
  coreOd
) => {
    const value =
       (parseFloat(weight) * 1000 * 1000 * parseFloat(bulk) * 4) /
          (3.14 *
            parseFloat(size) *
            (Math.pow(parseFloat(reelOd), 2) -
              Math.pow(parseFloat(coreOd), 2)));
           return (value.toFixed(3));
   
};

export const plannedReelsCalculations = (
    size,
    length,
    width,
    bulk,
    gsm,
    coreOd,
    reelOd,
    quantityValue,
    type
) => {
  const value =
      type === "weight"
        ? ((quantityValue ? parseFloat(quantityValue) : 0) *
            1000 *
            1000 *
            parseFloat(bulk) *
            4) /
          (3.14 *
            parseFloat(size) *
            (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)))
        : (parseFloat(length) *
            parseFloat(width) *
            parseFloat(quantityValue) *
            parseFloat(gsm) *
            parseFloat(bulk) *
            4) /
          (3.14 *
            parseFloat(size) *
            (Math.pow(parseFloat(reelOd), 2) -
              Math.pow(parseFloat(coreOd), 2)) *
            10000);
    return (value?.toFixed(3));
};